import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Header, Segment, Accordion, Icon, Button } from 'semantic-ui-react';

class FAQ extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }
  render() {
    const { activeIndex } = this.state
    return (
      <div>
        <Helmet>
          <title>FAQ</title>
          <meta name='description' content='BeemaBroker FAQ'/>
        </Helmet>
        <Segment style={{ padding: '8em 0em', backgroundColor:'#5AD0D2' }} vertical>
          <Grid container stackable>
            <Grid.Row>
              <Grid.Column width={16}>
                 <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> FAQ </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column width={16} centered='true'>
                <Accordion fluid>

                  <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                    <Icon name='dropdown' />
                    <b style={{ fontSize: '2em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>Can I work with BeemaBroker if I already have an insurance policy in place?</b>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <p style={{fontSize: '1.5em', paddingLeft: '2em'}}>
                      Yes, you can transfer your existing insurance policy to BeemaBroker
                      for management and have no changes in your policy or payment plan.
                      We can also help you shop for new insurance quotes at the time of
                      transfer or at the policy’s renewal date.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
                    <Icon name='dropdown' />
                    <b style={{ fontSize: '2em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>How long does it take to transfer my existing policy to BeemaBroker?</b>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 2}>
                    <p style={{fontSize: '1.5em', paddingLeft: '2em'}}>
                      We will provide you with a “Broker of Record” letter that you will need
                      to sign and return to us. It can take the insurance carrier 5- 10 days
                      to process the request. To expedite the process you can request the
                      existing broker to “waive the waiting period”.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title active={activeIndex === 3} index={3} onClick={this.handleClick}>
                    <Icon name='dropdown' />
                    <b style={{ fontSize: '2em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>How does BeemaBroker make money?</b>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 3}>
                    <p style={{fontSize: '1.5em', paddingLeft: '2em'}}>
                      We receive commission from the insurance carrier for placing & managing insurance policies.
                    </p>
                  </Accordion.Content>


                  <Accordion.Title active={activeIndex === 5} index={5} onClick={this.handleClick}>
                    <Icon name='dropdown' />
                    <b style={{ fontSize: '2em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>Does BeemaBroker have videos that help explain some key business insurance concepts?</b>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 5}>
                    <p style={{fontSize: '1.5em', paddingLeft: '2em'}}>
                      Yes! Our Youtube channel has 9 short videos all under 2 mins explaining a few key business insurance concepts.
                      Subscribe to our channel to stay in the loop for future content. You can learn about the following
                      concepts on our Youtube channel:
                      <br/>
                      <list>
                        <ul>
                          <li> Why do I need insurance for my business? </li>
                          <li> What is workers comp? </li>
                          <li> Why is a workers comp audit important? </li>
                          <li> Why do I need a business auto policy? </li>
                          <li> How do I protect my home based business? </li>
                          <li> How can business income protect my business?</li>
                          <li> How do I protect my business against data breach?</li>
                          <li> How do I protect my business from sexual harassment?</li>
                          <li> How do I protect my business against claims made by clients for inadequate work or negligence?</li>
                          <li style={{paddingTop: '1em', listStyleType: 'none'}}>
                            <Button color='black' href='https://www.youtube.com/channel/UCUIO2qZ7aTtKOZ3wX1FbIZw'>
                              <Icon name='youtube' /> BeemaBroker Youtube Channel
                            </Button>
                          </li>
                        </ul>
                      </list>
                    </p>
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/js/FAQ.js